interface PaginationData {
  current_page: number
  total_pages: number
  total_count: number
  per_page: number
}

interface DataTableResultsProps {
  pagination: PaginationData
  object_name: string
}

const DataTableResults = ({ pagination, object_name = "results" }: DataTableResultsProps) => {
  const startItem = ((pagination.current_page - 1) * pagination.per_page) + 1
  const endItem = Math.min(pagination.current_page * pagination.per_page, pagination.total_count)

  return (
    <div className="text-sm text-muted-foreground text-center mb-4">
      Showing {startItem} to {endItem} of {pagination.total_count} {object_name}
    </div>
  )
}

export default DataTableResults